import axios from '@/helpers/http-common';

const reminders = (
    page: number = 1,
    perPage: number = 10,
    search: string = '',
    archived: boolean = false,
    sortBy: string = '',
    sortDesc: boolean = false,
    assignee: string = '',
    futureReminders: boolean = false,
) => {
    return axios.get(`/dashboard/reminders?\
page=${page}&\
per_page=${perPage}&\
search=${search}&\
archived=${archived}&\
order_by=${sortBy}&\
order_desc=${sortDesc}&\
assignee=${assignee}&\
future=${futureReminders}`);
};

export const dashboardService = {
    reminders,
};
